import {IGameConfig} from '../incase-domain/proptypes/gameConfig';
import {IQuestionAnswerType} from '../incase-domain/elements/base/questionElementBase';
import {IGamifiable} from '../incase-domain/elements/base/gamifiable';

export const getNewPoints = (
    points: number,
    answerType: IQuestionAnswerType | boolean,
    gameConfigPres: IGameConfig,
    gameConfigEl: IGamifiable['gameConfig']
): number => {
    if (answerType === 'debatable') return points;

    const correct = gameConfigEl?.correctPointsPlus ?? gameConfigPres.correctPointsPlus;
    const inCorrect = gameConfigEl?.wrongPointsMinus ?? gameConfigPres.wrongPointsMinus;

    return points + (answerType === 'correct' || answerType === true ? correct : -inCorrect);
};

export const getNewPointsMultiple = (
    points: number,
    numOfCorrect: number,
    numOfWrong: number,
    gameConfigPres: IGameConfig,
    gameConfigEl: IGamifiable['gameConfig']
): number => {
    const correct = gameConfigEl?.correctPointsPlus ?? gameConfigPres.correctPointsPlus;
    const inCorrect = gameConfigEl?.wrongPointsMinus ?? gameConfigPres.wrongPointsMinus;

    return points + (numOfCorrect * correct + numOfWrong * -inCorrect);
};
